import { useEffect, useState } from "react";
import axios from "axios";
// import uuid from "react-uuid";

export const ApiGet = () => {
    // const apiUrl = "https://ict.mju.ac.th/api/activities.php";
    // const apiUrl = "https://faed.mju.ac.th/dev/nusoap82/activities.php";
    // const apiUrl = "https://aed.mju.ac.th/api/activityDBMS/";
    const apiUrl = process.env.REACT_ACT_API_URL;
    // const apiUrl = "https://ict.mju.ac.th/api/_train_regis_ext.php?method=get&round_no=2024-01-11_20857059";
    // const apiUrl = "https://faed.mju.ac.th/ActivityDBMS/_api?limit=6&owner=arch";
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    // const apiKey = "Bearer 86532a30-acf0-455d-8879-d1c0f43fb1b0";

    useEffect(() => {
        // const headers = {
        //     "Content-Type": "application/json",
        //     Authorization: apiKey,
        // };
        const fetchData = async () => {
            try {
                // * Using fetch
                // const response = await fetch(apiUrl);
                // const result = await response.json();

                // * If using Axios
                const result = await axios.get(apiUrl);

                console.log("api data: ", result.data);
                setData(result.data);
                setLoading(false);
            } catch (e) {
                console.error("Error: ", e);
                setLoading(false);
            }
        };
        fetchData();
    }, [apiUrl]);

    return (
        <div>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <ul>
                    {data.map((item, index) => (
                        <li key={index}>
                            {/* {item.stdcode +
                                " | " +
                                item.name +
                                " " +
                                item.lastname +
                                " | " +
                                item.payment} */}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export const ApiGetTest = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // const headers = {
        //     "Content-Type": "application/json",
        //     Authorization: apiKey,
        // };
        const fetchData = async () => {
            try {
                // * Using fetch
                // const response = await fetch(apiUrl);
                // const result = await response.json();

                // * If using Axios
                const result = await axios.get(props.apiUrl);

                console.log("api data: ", result.data[props.dataName]);
                setData(result.data[props.dataName]);
                setLoading(false);
            } catch (e) {
                console.error("Error: ", e);
                setLoading(false);
            }
        };
        fetchData();
        // eslint-disable-next-line
    }, []);

    return (
        <div>
            {loading ? (
                <p>Loading...</p>
            ) : (
                <ul>
                    {data.map((item, index) => (
                        <li key={index}>
                            {/* {item.stdcode +
                                " | " +
                                item.name +
                                " " +
                                item.lastname +
                                " | " +
                                item.payment} */}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

// ! not working
// export const ApiGetTestWithKey = (props) => {
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const apiUrl="https://aed.mju.ac.th/api/arch/partners/"
//     // const ApiAuthToken = "Bearer 86532a30-acf0-455d-8879-d1c0f43fb1b0";
//     useEffect(() => {
//         // const config = {
//         //     method: "GET",
//         //     maxBodyLength: Infinity,
//         //     url: props.apiUrl,
//         //     "Content-Type": "application/json",
//         //     headers: {
//         //         Authorization: "Bearer 86532a30-acf0-455d-8879-d1c0f43fb1b0",
//         //     },
//         // };
//         const headerConfigs = {
//             Authorization: "Bearer 86532a30-acf0-455d-8879-d1c0f43fb1b0",
//         };
//         const fetchData = async () => {
//             try {
//                 // * Using fetch
//                 // const response = await fetch(apiUrl);
//                 // const result = await response.json();

//                 // * If using Axios
//                 const result = await axios.request(apiUrl, {
//                     headers: headerConfigs,
//                 });

//                 console.log("api data: ", result.data);
//                 // setData(result.data.response);
//                 // setLoading(false);
//             } catch (e) {
//                 console.error("Error: ", e);
//                 setLoading(false);
//             }
//         };
//         fetchData();
//         // eslint-disable-next-line
//     });

//     return (
//         <div>
//             {loading ? (
//                 <p>Loading...:{data}</p>
//             ) : (
//                 <ul>
//                     {data.map((item, index) => (
//                         <li key={index}>
//                             {/* {item.stdcode +
//                                 " | " +
//                                 item.name +
//                                 " " +
//                                 item.lastname +
//                                 " | " +
//                                 item.payment} */}
//                         </li>
//                     ))}
//                 </ul>
//             )}
//         </div>
//     );
// };
